import { CustomerRatingFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/CustomerRatingFilter'
import {
  DistanceFilters,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceFilters'

import {
  DistanceToInterestsFilter,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceToInterestsFilter'
import { FacilitiesFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/FacilitiesFilter'
import {
  HasAvailabilityFilter,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/HasAvailabilityFilter'
import {
  HasAvailabilityNextSeasonFilter,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/HasAvailabilityNextSeasonFilter'

import { PricePerPersonFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/PricePerPersonFilter'
import { SkiAreaFilters } from '@/scopes/search/search/pages/SearchPage/components/Filters/SkiAreaFilters'
import { TransportTypeFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/TransportTypeFilter'
import { CollapsibleRoot, space } from '@sunwebgroup/ui-components'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import styled from 'styled-components'
import { AccomodationTypeFilter } from './AccomodationTypeFilter'
import { CampaignsAndDiscountsFilter } from './CampaignsAndDiscountsFilter'
import { CollectionsFilter } from './CollectionsFilter'
import { DealFilter } from './DealFilter'
import { DestinationFilter } from './DestinationFilter'
import { IntelligentFilter } from './IntelligentFilter'
import { LastMinuteFilter } from './LastMinuteFilter'
import { MealPlanFilter } from './MealPlanFilter'
import { NumberOfRoomsFilter } from './NumberOfRoomsFilter'
import { StarsFilter } from './StarsFilter'
import { VacationTypeFilter } from './VacationTypeFilter'

const AccordionRoot = styled(Accordion.Root)`
  ${CollapsibleRoot} {
    margin-top: ${space('primitives_space_8')};
  }
`

export function Filters() {
  return (
    <AccordionRoot>
      <HasAvailabilityNextSeasonFilter />
      <HasAvailabilityFilter />
      <IntelligentFilter />
      <DestinationFilter />
      <SkiAreaFilters />
      <PricePerPersonFilter />
      <TransportTypeFilter />
      <AccomodationTypeFilter />
      <MealPlanFilter />
      <DealFilter />
      <CampaignsAndDiscountsFilter />
      <FacilitiesFilter />
      <StarsFilter />
      <DistanceFilters />
      <DistanceToInterestsFilter />
      <CustomerRatingFilter />
      <VacationTypeFilter />
      <LastMinuteFilter />
      <NumberOfRoomsFilter />
      <CollectionsFilter />
    </AccordionRoot>
  )
}
